import React, { useState } from "react";

export default function Contact() {
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    const form = e.target;

    setTimeout(() => {
      setLoading(false);
      setSubmitted(true);

      form.reset();

      setTimeout(() => setSubmitted(false), 4000);
    }, 1500);
  };

  return (
    <>
      {/* ⭐ PREMIUM CSS */}
      <style>{`
        .contact-section {
          padding: 90px 0;
          background: linear-gradient(135deg, #eef4ff, #ffffff);
        }

        .contact-title {
          font-size: 42px;
          font-weight: 800;
          text-align: center;
          margin-bottom: 15px;
          animation: fadeUp 1s;
        }

        .contact-sub {
          text-align: center;
          font-size: 17px;
          color: #666;
          margin-bottom: 50px;
          animation: fadeUp 1.2s;
        }

        .contact-glass {
          background: rgba(255,255,255,0.75);
          backdrop-filter: blur(12px);
          border-radius: 20px;
          padding: 35px;
          box-shadow: 0px 12px 40px rgba(0,0,0,0.12);
          border: 1px solid rgba(0,0,0,0.08);
          animation: fadeUp 1s ease forwards;
        }

        .contact-info-box {
          background: white;
          border-radius: 18px;
          padding: 25px;
          border: 1px solid rgba(0,0,0,0.08);
          box-shadow: 0px 10px 30px rgba(0,0,0,0.1);
          margin-bottom: 20px;
        }

        .contact-info-line {
          display: flex;
          align-items: center;
          margin-bottom: 12px;
          font-size: 16px;
          font-weight: 600;
        }

        .contact-info-line i {
          font-size: 22px;
          color: #005eff;
          margin-right: 12px;
        }

        iframe {
          width: 100%;
          height: 280px;
          border-radius: 18px;
          box-shadow: 0px 10px 30px rgba(0,0,0,0.1);
        }

        .form-control {
          border-radius: 12px;
          padding: 12px;
          border: 1px solid #cfd8ff;
          transition: 0.3s ease;
        }

        .form-control:focus {
          border-color: #005eff;
          box-shadow: 0 0 10px rgba(0,94,255,0.3);
        }

        .submit-btn {
          background: linear-gradient(90deg, #005eff, #003fcc);
          border: none;
          padding: 13px 28px;
          border-radius: 12px;
          font-size: 17px;
          font-weight: 600;
          color: white;
          transition: 0.3s ease;
          width: 100%;
        }

        .submit-btn:hover {
          transform: translateY(-3px);
          box-shadow: 0px 10px 25px rgba(0,64,201,0.3);
        }

        .thankyou, .loading {
          margin-top: 12px;
          font-size: 16px;
          font-weight: 600;
          animation: fadeUp 0.6s ease;
        }

        .thankyou { color: green; }
        .loading { color: #005eff; }

        @keyframes fadeUp {
          0% { opacity: 0; transform: translateY(20px); }
          100% { opacity: 1; transform: translateY(0); }
        }
      `}</style>

      {/* ⭐ SECTION */}
      <section className="contact-section">
        <div className="container">

          <h2 className="contact-title">Get in Touch</h2>
          <p className="contact-sub">We’re here to help you 24/7 with all your shipping needs.</p>

          <div className="row g-4">

            {/* LEFT SIDE — Contact Info + Map */}
            <div className="col-lg-5">
              <div className="contact-info-box">

                <h4 className="fw-bold mb-3">SWIFTSHIP Office</h4>

                <div className="contact-info-line">
                  <i className="bi bi-geo-alt-fill"></i>
                  3800 Cabell Dr, Irving, TX 75063, United States
                </div>

                <div className="contact-info-line">
                  <i className="bi bi-envelope-fill"></i>
                  info@swiftship.us
                </div>

                <div className="contact-info-line">
                  <i className="bi bi-telephone-fill"></i>
                  (480) 520-0274
                </div>
              </div>

              {/* MAP */}
              <iframe
                title="location"
                src="https://www.google.com/maps?q=4539%20N%2022ND%20ST,%20STE%20N,%20PHOENIX,%20AZ%2085016&output=embed"
              ></iframe>
            </div>

            {/* RIGHT SIDE — FORM */}
            <div className="col-lg-7">
              <div className="contact-glass">

                <h4 className="fw-bold mb-3">Send Us a Message</h4>

                <form onSubmit={handleSubmit}>

                  <input className="form-control mb-3" placeholder="Your Name" required />

                  <input className="form-control mb-3" placeholder="Phone Number" required />

                  <input className="form-control mb-3" placeholder="Your Email" required />

                  <textarea 
                    className="form-control mb-3" 
                    placeholder="Message" 
                    rows="4"
                    required
                  ></textarea>

                  <button className="submit-btn" type="submit" disabled={loading}>
                    {loading ? "Sending..." : "Send Message →"}
                  </button>

                  {loading && <div className="loading">Submitting your message...</div>}
                  {submitted && !loading && (
                    <div className="thankyou">Thank you! Your message has been sent.</div>
                  )}

                </form>
              </div>
            </div>

          </div>

        </div>
      </section>
    </>
  );
}
